import { Entity, Field } from "typegraph";

@Entity({one: "product", many: "products"})
export default class Product {

	@Field()
	public id: string;

	@Field()
	public smallIconURL: string;

	@Field()
	public iconURL: string;

	@Field()
	public name: string;

}



// WEBPACK FOOTER //
// ./src/panels/tracksProgram/entities/Product.ts